var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "#808080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0375 8.77875C17.892 8.77875 19.3954 7.29888 19.3954 5.47336C19.3954 3.64784 17.892 2.16797 16.0375 2.16797C14.183 2.16797 12.6797 3.64784 12.6797 5.47336C12.6797 7.29888 14.183 8.77875 16.0375 8.77875Z",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4125 21.2202C27.267 21.2202 28.7704 19.7403 28.7704 17.9148C28.7704 16.0892 27.267 14.6094 25.4125 14.6094C23.5581 14.6094 22.0547 16.0892 22.0547 17.9148C22.0547 19.7403 23.5581 21.2202 25.4125 21.2202Z",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58442 21.2202C8.43891 21.2202 9.94228 19.7403 9.94228 17.9148C9.94228 16.0892 8.43891 14.6094 6.58442 14.6094C4.72993 14.6094 3.22656 16.0892 3.22656 17.9148C3.22656 19.7403 4.72993 21.2202 6.58442 21.2202Z",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3398 5.95703C21.1843 6.60176 22.7924 7.77152 23.9601 9.31776C25.1278 10.864 25.8023 12.717 25.8981 14.6413",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17969 14.6333C6.2769 12.7144 6.9496 10.8668 8.11285 9.32397C9.27609 7.78113 10.8777 6.61222 12.7154 5.96484",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.972 20.8985C23.0522 22.1211 21.8537 23.1141 20.4728 23.7974C19.092 24.4807 17.5674 24.8353 16.0219 24.8327C14.4764 24.83 12.9532 24.4701 11.5748 23.782C10.1963 23.094 9.00134 22.0969 8.08594 20.8711",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.ca65e9d5a3389973550c196d872d271a.svg";
export { ForwardRef as ReactComponent };